// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__16Yej","item":"PaymentsMobile_item__3xU2T","label":"PaymentsMobile_label__1-yuK","amount":"PaymentsMobile_amount__33z22"};